import htmx from "htmx.org"

declare global {
  interface Window {
    htmx: typeof htmx
  }
}

htmx.config.scrollIntoViewOnBoost = false
htmx.config.defaultSwapStyle = "outerHTML"

window.htmx = htmx
